import { object, string } from 'yup';

import { getFormValidator } from '@util/form/get-form-validator';

export const newWebhookFormValidation = getFormValidator(
  object().shape({
    deliveryUrl: string().required().url(),
  }),
);
